import { render, staticRenderFns } from "./HrSalaryRegistHoliday.vue?vue&type=template&id=bf96d95c&scoped=true&"
import script from "./HrSalaryRegistHoliday.vue?vue&type=script&lang=js&"
export * from "./HrSalaryRegistHoliday.vue?vue&type=script&lang=js&"
import style0 from "./HrSalaryRegistHoliday.vue?vue&type=style&index=0&id=bf96d95c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf96d95c",
  null
  
)

export default component.exports